import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => {
  return {
    control: {
      padding: theme.spacing(2),
    },
    formControl: {
      minWidth: 120,
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "white",
    },
    textField: {
      marginBottom: theme.spacing(2),
    },
    billingSectionHeader: {
      fontSize: 22,
      fontWeight: "bold",
      marginTop: 0,
    },
  };
});

export default useStyles;
